import React from "react";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import ModalTreeChildren from "../sideMenu/TreeChildren";
import MyContext from "../../../api/context/my-context";
import * as Common from "../../common/common";

class FolderManagement extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);

    this.wrapperRef = React.createRef();

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      treekey: props.treekey,
      token: null,
      treeList: [],
      treeListUpdate: [],
      treeCount: 0,
      hiddenActive: true,
      folderName: "",
      deleteCheck: false,
    };
  }
  handleEvent() {
    var tree = this.state.treeList;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treeListUpdate: this.state.treeListUpdate,
      treekey: this.props.treekey,
      folderName: this.state.folderName,
      hiddenActive: this.state.hiddenActive,
      deleteCheck: this.state.deleteCheck,
    };
  }

  allTree = {
    treeList: [],
    treecount: null,
  };
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  GetTreeStructure(model, isUpdate) {
    var that = this;

    Common.GetTreeStructure("", model, that.state.token, isUpdate).then(
      function (TreeResult) {
        if (TreeResult != undefined) {
          if (!isUpdate) {
            // var result = list_to_tree(list, 0);
            that.setState({ treeList: [] });
            that.setState({
              treeList: TreeResult.treeList.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase()) {
                  return -1;
                }
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                  return 1;
                }
                return 0;
              }),
            });
          } else {
            that.allTree.treeList = TreeResult.treeList;
            that.allTree.treecount = TreeResult.treecount;
          }
        }
      }
    );
  }
  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      that.model.content[0].values[0] = that.state.treekey;

      that.GetTreeStructure(that.model);
    }
  }
  async componentDidMount() {
    var that = this;
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenPopup(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
        treeList: null,
      });
    }

    $("#modal_koppel_aan_folder").on("show.bs.modal", async function (event) {
      await that.GetTreeStructure(that.model);
    });

    // that.GetTreeStructure(that.model);
  }
  render() {
    this.handleEvent();

    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="modal_koppel_aan_folder"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Plaats in map</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div class="beheeractiviteit-boom-content">
                <div className="modal-scroll">
                  <div id="boom-structuur" className="radio-grp">
                    <p>Boomstructuur</p>
                    <div ref={this.wrapperRef}>
                      <MyContext.Consumer>
                        {(context) => (
                          <div>
                            <ModalTreeChildren
                              TreeList={
                                context.store.treeCount == null
                                  ? this.state.treeList
                                  : context.store.treeCount !=
                                    this.state.treeCount
                                  ? context.store.treeList
                                  : this.state.treeList
                              }
                              componentName={this.state.tabName}
                              pathname={this.state.menuName}
                              treeLocation="modal"
                            />
                          </div>
                        )}
                      </MyContext.Consumer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id={this.props.buttonId}
                className="btn-modal"
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FolderManagement;
